import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'cargoes-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.less']
})
export class PageTitleComponent implements OnInit {

  @Input() title: any;
  @Input() referenceNumber: any;
  @Input() isBack = false;
  @Input() status: any;
  copyReferenceNumber = { tooltipIcon: "", tooltipText: "" };
  copiedMsg:boolean = false;
  constructor(private location: Location) { }

  ngOnInit() {
  }

  onBack(){
    this.location.back();
  }

  copyMessage(text: string) {
    const event = (e: ClipboardEvent) => {
      e.clipboardData!.setData("text/plain", text);
      e.preventDefault();
    };
    document.addEventListener("copy", event);
    document.execCommand("copy");
    document.removeEventListener('copy', event);
    this.copyReferenceNumber.tooltipIcon = "check-circle";
    this.copyReferenceNumber.tooltipText = "Copied";
    this.copiedMsg = true;
    setTimeout(() => {
      this.copyReferenceNumber.tooltipIcon = "snippets";
      this.copyReferenceNumber.tooltipText = "Copy";
      this.copiedMsg = false;
    }, 1500);
  }

}
